import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Tpn } from "../models/tpn.model";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api/";

// console.log(BASE_URL)

const safeWh = (wh: any) => (wh && wh !== "undefined" && wh !== "null" ? wh : "allWh");

export const TpnApi = createApi({
  reducerPath: "tpnApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  tagTypes: ["Tpn"],
  endpoints: (builder) => ({
    Tpns: builder.query<Tpn[], void>({
      query: () => "/tpn",
      providesTags: ["Tpn"],
    }),
    TpnsCount: builder.query<Tpn[], any>({
      query: (arg) => {
        const aamarId = typeof arg === "object" ? arg?.aamarId : arg;
        return `/tpn/count/${aamarId || ""}`;
      },
      providesTags: ["Tpn"],
    }),
    Tpnwh: builder.query<Tpn[], any>({
      query: ({warehouse,aamarId}) => `/tpn/wh/${aamarId}/${safeWh(warehouse)}`,
      providesTags: ["Tpn"],
    }),
    Tpn: builder.query<Tpn, string>({
      query: (_id) => `/tpn/${_id}`,
      providesTags: ["Tpn"],
    }),
    TpnByDate: builder.query<Tpn, any>({
      query: ({ startDate, endDate, warehouse, aamarId }) =>
        `/tpn/byDate/${startDate}/${endDate}/${safeWh(warehouse)}/${aamarId}`,
      providesTags: ["Tpn"],
    }),
    TpnDetails: builder.query<Tpn, any>({
      query: ({ startDate, endDate, warehouse, aamarId }) =>
        `/tpn/details/${startDate}/${endDate}/${safeWh(warehouse)}/${aamarId}`,
      providesTags: ["Tpn"],
    }),
    TpnSummary: builder.query<Tpn, any>({
      query: ({ startDate, endDate, warehouse, aamarId }) =>
        `/tpn/summary/${startDate}/${endDate}/${safeWh(warehouse)}/${aamarId}`,
      providesTags: ["Tpn"],
    }),
    addTpn: builder.mutation<{}, Tpn>({
      query: (Tpn) => ({
        url: "/tpn",
        method: "POST",
        body: Tpn,
      }),
      invalidatesTags: ["Tpn"],
    }),
    updateTpn: builder.mutation<void, Tpn>({
      query: ({ _id, ...rest }) => ({
        url: `/tpn/${_id}`,
        method: "PUT",
        body: rest,
      }),
      invalidatesTags: ["Tpn"],
    }),
    deleteTpn: builder.mutation<void, string>({
      query: (id) => ({
        url: `/tpn/delete/${id}`,
        method: "PUT",
      }),
      invalidatesTags: ["Tpn"],
    }),
  }),
});

export const {
  useTpnsQuery,
  useTpnwhQuery,
  useTpnQuery,
  useTpnDetailsQuery,
  useTpnSummaryQuery,
  useTpnByDateQuery,
  useAddTpnMutation,
  useUpdateTpnMutation,
  useDeleteTpnMutation,
} = TpnApi;

export default TpnApi;
